import { useQuery } from '@tanstack/react-query';
import type { UseQueryResult } from '@tanstack/react-query';

import { api } from '../client';
import { queryKeys } from '../keys';
import type { Envelope, SiteSettings } from '../types';

/** Admin edits are rare and the backend caches the row; one fetch per visit is plenty. */
const SITE_SETTINGS_STALE_MS = 10 * 60 * 1000;

/**
 * `GET /api/site/settings` - admin-managed SEO meta + analytics id, read by the
 * public layout on every page (document meta, og tags, gtag).
 */
export function useSiteSettings(): UseQueryResult<SiteSettings> {
  return useQuery({
    queryKey: queryKeys.site.settings(),
    staleTime: SITE_SETTINGS_STALE_MS,
    queryFn: async () => {
      const res = await api.get<Envelope<SiteSettings>>('/site/settings');
      return res.data;
    },
  });
}
